import axiosHook from '../axios';
import axiosAll from '../axiosAll';

export default {
  /* NICE */
  // nice 핸드폰 번호 수정
  patchNiceAuthPhoneNumber() {
    return axiosHook('patch', '/api/member/nice/phone-number');
  },

  // nice 본인인증
  niceAuthCheck() {
    return axiosHook('get', '/api/login/nice-id/data');
  },

  // nice 핸드폰 번호 가져오기
  getNiceAuthPhoneNumber() {
    return axiosHook('get', '/api/member/nice/phone-number-check');
  },

  /* 권한별 메뉴 */
  getMenuList() {
    return axiosHook('get', '/api/menu');
  },

  /* 유틸리티 */
  // 로그인
  login(params) {
    return axiosHook('post', '/api/actionLogin.json', params);
  },

  // 로그아웃
  logout() {
    return axiosHook('post', '/api/actionLogout.json');
  },

  // 아이디 중복체크
  duplicateId(checkId) {
    return axiosHook('get', `/api/member/check-duplicate/${checkId}`);
  },

  /* 일반 회원 */
  // 일반회원 최초 로그인 정보 등록
  registerGeneralMemberInfo(params) {
    return axiosHook('post', '/api/member/user', params);
  },

  // 일반회원 정보 조회
  getGeneralMeberInfo() {
    return axiosHook('get', '/api/member/user');
  },

  /* 사업자 회원 */
  // 사업자 회원가입
  signupBusiness(params) {
    return axiosHook('post', '/api/member/bsn', params);
  },

  // 사업자번호 확인
  checkBusinessLicense(companyNo) {
    return axiosHook('get', `/api/member/bsn/validate/${companyNo}`);
  },

  // 사업자번호 중복 확인
  duplicateBusinessLicense(companyNo) {
    return axiosHook('get', `/api/member/bsn/check-duplicate/${companyNo}`);
  },

  /* 사업자 아이디 찾기 */
  // 사업자 아이디 찾기
  findBusinessId(params) {
    return axiosHook('get', `/api/member/bsn/find-id`, params);
  },

  // 사업자 아이디 찾기 - 휴대전화 본인인증
  findBusinessIdAuthCheck() {
    return axiosHook('get', `/api/member/bsn/nice/find-id`);
  },

  /* 사업자 비밀번호 찾기 */
  // 사업자 비밀번호 변경 - 휴대전화 본인인증
  changePasswordAuthCheck() {
    return axiosHook('get', `/api/member/nice/auth`);
  },

  // 사업자 비밀번호 변경
  changeBusinessPassword(params) {
    return axiosHook('patch', `/api/member/pw-change`, params);
  },

  /* 통합검색 */
  // 통합 조회 -> 메뉴, 공지사항, 자주하는 질문
  async getUnifiedSearch(keyword) {
    const urls = [
      `/api/sitemap?searchKeyword=${keyword}`,
      `/api/board/NOTICE/list?pageIndex=1&pageSize=99999&searchCondition=TITLE&searchKeyword=${keyword}`,
      `/api/board/FAQ/list?pageIndex=1&pageSize=99999&searchCondition=ALL&searchKeyword=${keyword}`,
    ];

    const response = await axiosAll(urls);

    const [menuObj, noticeObj, faqObj] = response;

    const item = {
      menuObj,
      noticeObj,
      faqObj,
    };

    return item;
  },
};
